import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, Chip, Divider, InputAdornment, MenuItem, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
// components
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import FormProvider, {
  RequiredLabel,
  RHFAutocomplete,
  RHFSelect,
  RHFTextField,
} from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { DatePicker } from '@mui/x-date-pickers';
import { INVOICE_SERVICE_OPTIONS, JOB_SKILL_OPTIONS } from 'src/_mock';
import { Stack } from '@mui/system';
import AssignPage from './assign-page/assign-page';
import { useData } from 'src/contexts/gantt-chart/gantt-context';
import { LoadingScreen } from '../loading-screen';
import { dateformation, dateformation2 } from '../date-format-mdy';

// ----------------------------------------------------------------------

export default function AssignUserAtDate({gantt, selectedDate, open, onClose }) {
  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState('');
  const { getDateWiseAssigment,getDateWiseAssigmentLoading } = useData();

  // Validation schema
  const NewUserSchema = Yup.object().shape({
    start_date: null,
  });

  const defaultValues = useMemo(
    () => ({
      start_date: selectedDate,
    }),
    [selectedDate]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });
  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const values = watch();

  useEffect(() => {
    getDateWiseAssigment(dateformation2(selectedDate))
    reset(defaultValues);
  }, [reset, defaultValues]);

  const onSubmit = handleSubmit(async (value) => {});
  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      open={open}
      onClose={() => {
        onClose();
        reset();
      }}
    >
      {/* <FormProvider methods={methods} onSubmit={onSubmit}> */}
        <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3), background: '#F4F6F8', mb: 2 }}>
          Assign Resources To Activity
          <Iconify
            icon="ri:close-line"
            style={{ position: 'absolute', right: '30px', cursor: 'pointer' }}
            onClick={() => {
              onClose();
              reset();
            }}
          />
        </DialogTitle>

   {getDateWiseAssigmentLoading ? <Box height={400}>
    <LoadingScreen/>
   </Box> :     <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
          {/* <Divider sx={{marginTop:"10px"}}/> */}
          <AssignPage selectedDate={selectedDate} close={onClose} gantt={gantt}/>
        </DialogContent>}

      {/* </FormProvider> */}
    </Dialog>
  );
}

AssignUserAtDate.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
